module.exports = __webpack_public_path__ + "img/4.af70a893.jpg";